import { format, setDate } from "date-fns";
import { InvoiceType, JEType } from "./Modal/GSTType";
import { AdvanceAndReferenceTypes } from "../StaticData/common";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { saveAs } from "file-saver";
import {
  alpha,
  InputBaseComponentProps,
  Menu,
  MenuProps,
  styled,
} from "@mui/material";
import { EncryptDecryptService } from "../Services/common/EncryptionService";

export function contactFormat(value: any) {
  if (!value) return;
  value = value.replace(/^(\d{5})/, "$1 ");
  return value;
}

export function numberFormat(
  item: any,
  minimumFractionDigits?: number,
  maximumFractionDigits?: number
) {
  const options: any = {
    style: "currency",
    currency: "INR",
  };

  if (minimumFractionDigits !== undefined) {
    options.minimumFractionDigits = minimumFractionDigits;
  }

  if (maximumFractionDigits !== undefined) {
    options.maximumFractionDigits = maximumFractionDigits;
  }

  return new Intl.NumberFormat("en-IN", options).format(item).replace(/₹/g, "");
}

export const NumberFormatWithSymbol = ({
  amount,
  symbol = "₹",
  country = "en-IN",
}: any) => {
  // Format the amount using Intl.NumberFormat for better formatting
  const formattedAmount = new Intl.NumberFormat(country || "en-IN", {
    style: "currency",
    currency: symbol === "₹" ? "INR" : symbol,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));

  return (
    <span>{amount < 0 ? `-${formattedAmount}` : `${formattedAmount}`}</span>
  );
};

export function numberFormatWithCrDr(item: any, nature: string) {
  let formattedNumber = "";
  nature = nature === "CR" ? "Cr" : "Dr";

  nature = item < 0 ? (nature === "Cr" ? "Dr" : "Cr") : nature;

  item = Math.abs(item);
  formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  })
    .format(item)
    .replace(/₹/g, "");

  formattedNumber = formattedNumber + " " + nature;
  return formattedNumber;
}

export function getSingleSelected(selectedValue: any, sourceList: any) {
  let result = sourceList.find((o: any) => o.value === selectedValue);
  return result;
}

export function numDifferentiation(value: any, decimalFixes: any) {
  let result = value.toFixed(decimalFixes);
  let val = Math.abs(value);
  if (val >= 10000000) {
    result = (val / 10000000).toFixed(decimalFixes);
  } else if (val >= 100000) {
    result = (val / 100000).toFixed(decimalFixes);
  } else if (val >= 1000) {
    result = (val / 1000).toFixed(decimalFixes);
  } else {
    result = val.toFixed(decimalFixes);
  }

  if (value < 0) {
    return "-₹" + result;
  } else {
    return "₹" + result;
  }
}

export function numNagativePositiveWhole(value: any, decimalFixes: any) {
  let result = value.toFixed(decimalFixes);
  let val = Math.abs(value);
  if (value < 0) {
    return (result = "-₹" + val);
  } else {
    return (result = "₹" + val);
  }
}

export function numDifferentiationForText(value: any) {
  let result = "";
  let val = Math.abs(value);
  if (val >= 10000000) {
    result = "Crores";
  } else if (val >= 100000) {
    result = "Lakhs";
  } else if (val >= 1000) {
    result = "Thousands";
  } else {
    result = "Rupees";
  }
  return result;
}

export function getCurrentFinancialYear() {
  let financialYear = "";
  let startYear = 0;
  let endYear = 0;
  let docDate = new Date();

  if (new Date().getMonth() > 2) {
    startYear = docDate.getFullYear();
    endYear = docDate.getFullYear() + 1;
    let tempFinancialYear = startYear + "-" + endYear;
    financialYear = tempFinancialYear;
  } else {
    startYear = docDate.getFullYear() - 1;
    endYear = docDate.getFullYear();
    let tempFinancialYear = startYear + "-" + endYear;
    financialYear = tempFinancialYear;
  }
  return financialYear;
}

export function getCurrentFinancialYearStartDate() {
  let startYearDate = new Date();
  let startYear = 0;
  let docDate = new Date();
  if (new Date().getMonth() > 2) {
    startYear = docDate.getFullYear();
    startYearDate = new Date(startYear, 3, 1);
  } else {
    startYear = docDate.getFullYear() - 1;
    startYearDate = new Date(startYear, 3, 1);
  }
  let finalstartYearDate = format(new Date(startYearDate), "yyyy-MM-dd");
  return finalstartYearDate;
}

export function getCurrentFinancialYearEndDate() {
  let endYearDate = new Date();
  let endYear = 0;
  let docDate = new Date();
  if (new Date().getMonth() > 2) {
    endYear = docDate.getFullYear() + 1;
    endYearDate = new Date(endYear, 2, 31);
  } else {
    endYear = docDate.getFullYear();
    endYearDate = new Date(endYear, 2, 31);
  }
  let finalendYearDate = format(new Date(endYearDate), "yyyy-MM-dd");
  return finalendYearDate;
}

export function getStartDate() {
  let startDate = new Date();
  if (startDate.getMonth() === 3) {
    startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  } else {
    startDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      1
    );
  }
  return startDate;
}

export function getEndDate() {
  let endDate = new Date();
  if (endDate.getMonth() === 3) {
    endDate = new Date();
  } else {
    endDate.setDate(0);
  }
  return endDate;
}

export function getSaleType(value: any) {
  let result: any = InvoiceType.AllInvoice;
  let val = value.toLowerCase();
  if (val === "tax-invoice") {
    result = InvoiceType.TaxInvoice;
  } else if (val === "proforma-invoice") {
    result = InvoiceType.Proforma;
  } else if (val === "quotation-estimate") {
    result = InvoiceType.Quotation;
  } else if (val === "labour-invoice") {
    result = InvoiceType.LabourInvoice;
  } else if (val === "composition-invoice") {
    result = InvoiceType.CompositionInvoice;
  } else if (val === "bom-invoice") {
    result = InvoiceType.Bom;
  }
  return result;
}

export function getTableName(value: any) {
  let result: any = "";
  let val = value.toLowerCase();
  if (val === "tax-invoice") {
    result = "Sale";
  } else if (val === "proforma-invoice") {
    result = "Proforma";
  } else if (val === "quotation-estimate") {
    result = "Quotation";
  } else if (val === "labour-invoice") {
    result = "Labour";
  } else if (val === "composition-invoice") {
    result = "Sale";
  } else if (val === "bom-invoice") {
    result = "Sale";
  }
  return result;
}

export function getJournalEnteriesType(value: any) {
  let result: any = JEType.AllJE;
  let val = value.toLowerCase();
  if (val === "payment") {
    result = JEType.Payment;
  } else if (val === "receipt") {
    result = JEType.Receipt;
  } else if (val === "contra") {
    result = JEType.Contra;
  } else if (val === "journal") {
    result = JEType.JournalVoucher;
  }
  return result;
}

export function getJournalEnteriesTypePageName(value: any) {
  let result: any = "JE";
  let val = value.toLowerCase();
  if (val === "payment") {
    result = "Payment ";
  } else if (val === "receipt") {
    result = "Receipt ";
  } else if (val === "contra") {
    result = "Contra ";
  } else if (val === "journal") {
    result = "Journal ";
  }
  return result;
}
export function getVoucherConfigModule(voucherTypeName: string): string {
  const val = voucherTypeName?.toLowerCase();
  if (val === "payment") return "VOUCHER";
  if (val === "receipt") return "RECEIPT_VOUCHER";
  if (val === "contra") return "CONTRA_VOUCHER";
  if (val === "journal") return "JOURNAL_VOUCHER";
  return "VOUCHER";
}
export function getJournalEnteriesTypeTableName(value: any) {
  let result: any = "JE";
  let val = value.toLowerCase();
  if (val === "payment") {
    result = "Payment Voucher";
  } else if (val === "receipt") {
    result = "Receipt Voucher";
  } else if (val === "contra") {
    result = "Contra Voucher";
  } else if (val === "journal") {
    result = "Journal Voucher";
  }
  return result;
}

export function getJournalEnteriesCapitalizeType(value: any) {
  let result: any = "JE";
  let val = value.toLowerCase();
  if (val === "payment") {
    result = "VOUCHER_PAYMENT";
  } else if (val === "receipt") {
    result = "VOUCHER_RECEIPT";
  } else if (val === "contra") {
    result = "VOUCHER_CONTRA";
  } else if (val === "journal") {
    result = "VOUCHER_JOURNAL";
  }
  return result;
}

export function getSaleTypePageName(value: any) {
  let result: any = "Invoices";
  let val = value.toLowerCase();
  if (val === "tax-invoice") {
    result = "Invoices (GST)";
  } else if (val === "proforma-invoice") {
    result = "Sales Order";
  } else if (val === "quotation-estimate") {
    result = "Quotation/Estimates";
  } else if (val === "labour-invoice") {
    result = "Labour Invoices";
  } else if (val === "composition-invoice") {
    result = "Invoices";
  }
  return result;
}

export function getSaleSaveTypePageName(value: any) {
  let result: any = "Invoices";
  let val = value.toLowerCase();
  if (val === "tax-invoice") {
    result = "Invoice (GST)";
  } else if (val === "proforma-invoice") {
    result = "Sales Order";
  } else if (val === "quotation-estimate") {
    result = "Quotation/Estimates";
  } else if (val === "labour-invoice") {
    result = "Labour Invoice";
  } else if (val === "composition-invoice") {
    result = "Invoice";
  }
  return result;
}

export function getSaleTypeName(value: any) {
  let result: any = "Invoices";
  let val = value.toLowerCase();
  if (val === "tax-invoice") {
    result = "SALE";
  } else if (val === "proforma-invoice") {
    result = "PROFORMA";
  } else if (val === "quotation-estimate") {
    result = "QUOTATION";
  } else if (val === "labour-invoice") {
    result = "LABOUR";
  } else if (val === "composition-invoice") {
    result = "SALE";
  } else if (val === "bom-invoice") {
    result = "SALE";
  }
  return result;
}

export function getNameSelected(selectedValue: any, sourceList: any) {
  let result = sourceList.find(
    (o: { value: any }) => o.value === selectedValue
  );
  return result === undefined || result === "" ? "" : result.label;
}

export const convertToUpperCase = (value: any) => {
  return value?.toString()?.toUpperCase();
};

export function getMonthStartAndEndDate(month: number, year: number) {
  if (month < 1 || month > 12) {
    throw new Error(
      "Invalid month number. Month number should be between 1 and 12."
    );
  }

  const startDate = new Date(year, month - 1, 1); // Subtract 1 from month to adjust for zero-based indexing
  const endDate = new Date(year, month, 0); // Day 0 of the next month is the last day of the current month

  return {
    startDate,
    endDate,
  };
}

export function isElementVisible(element: any) {
  return element.offsetWidth > 0 || element.offsetHeight > 0;
}

export function ExportFilesFunction(
  attachmentName: string,
  attachmentType: string,
  attachmentData: any
) {
  let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any)?.MSStream;
  let isChrome: any =
    navigator.userAgent.toLowerCase().indexOf("CriOS") > -1 ||
    navigator.vendor.toLowerCase().indexOf("google") > -1;
  let iOSVersion: any = [];
  if (iOS) {
    iOSVersion = navigator?.userAgent
      .match(/OS [\d_]+/i)?.[0]
      .substr(3)
      .split("_")
      .map((n) => parseInt(n));
  }
  let contentType = "";
  let blobMediaType = "";
  if (attachmentType === "pdf") {
    contentType = "application/pdf";
    blobMediaType = `data:application/pdf;df:`;
  } else {
    contentType = "application/msexcel";
    blobMediaType = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,`;
  }
  let binary = atob(attachmentData.replace(/\s/g, ""));
  let len = binary.length;
  let buffer = new ArrayBuffer(len);
  let view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  let linkElement = document.createElement("a");
  try {
    let hrefUrl = "";
    let blob: any = "";
    if (iOS && !isChrome && iOSVersion[0] <= 12) {
      blob = blobMediaType + attachmentData;
      hrefUrl = blob;
    } else {
      if (iOS && !isChrome) {
        contentType = "application/octet-stream";
      }
      blob = new Blob([view], { type: contentType });
      hrefUrl = window.URL.createObjectURL(blob);
    }
    linkElement.setAttribute("href", hrefUrl);
    linkElement.setAttribute("target", "_blank");
    if ((iOS && (iOSVersion[0] > 12 || isChrome)) || !iOS) {
      linkElement.setAttribute("download", attachmentName);
    }
    let clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: false,
    });
    linkElement.dispatchEvent(clickEvent);
    // linkElement.remove();
  } catch (ex) {
    console.log("file export error: ", ex);
  }
}

export function ExportFilesFunction2(
  attachmentName: string,
  attachmentType: string,
  attachmentData: string
) {
  const byteCharacters = atob(attachmentData);
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {
    type:
      attachmentType === "pdf"
        ? "application/pdf"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  try {
    saveAs(blob, attachmentName);
  } catch (err) {
    console.error("File export failed:", err);
  }
}

export function getReferenceAdjustmentType(value: string) {
  const adjRef = AdvanceAndReferenceTypes.find((x) => x.value === value);
  return adjRef?.label;
}

export function dataURLtoFile(dataurl: any, filename: any) {
  if (!dataurl || typeof dataurl !== 'string') {
    return null;
  }

  var arr = dataurl?.split(","),
    mimeMatch = arr[0]?.match(/:(.*?);/),
    mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream',
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export const handleFocus = (event: any) => event?.target?.select();
export const handleFocusOut = (event: any) => {
  event.preventDefault();
};

export function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function removeSpacesAndLowercase(input: any) {
  return input.replace(/\s+/g, "").toLowerCase();
}

export const getStartDateOnInit = (userContext: any) => {
  const edMonth = new Date(userContext.financialYearEndDate).getMonth() + 1;
  const edYear = new Date(userContext.financialYearEndDate).getFullYear();
  if (userContext.financialYear !== userContext.currentFinancialYear) {
    return new Date(edYear + "-" + edMonth + "-" + "01");
  } else {
    return getStartDate();
  }
};
export const getEndDateOnInit = (userContext: any) => {
  if (userContext.financialYear !== userContext.currentFinancialYear) {
    return new Date(userContext.financialYearEndDate);
  } else {
    return getEndDate();
  }
};

export const getSelectStyles = () => {
  const isDark =
    typeof document !== "undefined" &&
    document.documentElement.getAttribute("data-theme") === "dark";
  const textColor = isDark ? "#F1F5F9" : "black";
  const mutedColor = isDark ? "#94A3B8" : "gray";
  const surfaceColor = isDark ? "#151C26" : "white";
  const controlBorder = isDark ? "1px solid #293241" : "1px solid $grey-100";
  const controlBorderFocus = isDark ? "1px solid #6366F1" : "1px solid black";
  const indicatorHover = isDark ? "#F1F5F9" : "black";

  return {
    control: (basestyle: any, state: any) => ({
      ...basestyle,
      backgroundColor: isDark ? "#0B0F14" : basestyle.backgroundColor,
      color: isDark ? textColor : basestyle.color,
      border: state.isFocused ? controlBorderFocus : controlBorder,
      boxShadow: "none",
      "&:hover": {
        border: controlBorderFocus,
      },
    }),
    placeholder: (basestyle: any, state: any) => ({
      ...basestyle,
      color:
        state.hasValue || state.selectProps.inputValue
          ? state.isFocused
            ? isDark
              ? "#818CF8"
              : "#25258f"
            : mutedColor
          : mutedColor,
      overflow: "hidden",
      backgroundColor:
        state.hasValue || state.selectProps.inputValue
          ? surfaceColor
          : "transparant",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      position:
        state.hasValue || state.selectProps.inputValue ? "absolute" : "static",
      top: state.hasValue || state.selectProps.inputValue ? -15 : "10%",
      transition: "top 0.3s, font-size 0.1s",
      fontSize: (state.hasValue || state.selectProps.inputValue) && 10,
      paddingLeft:
        state.hasValue || state.selectProps.inputValue ? "3px" : "0px",
      paddingRight:
        state.hasValue || state.selectProps.inputValue ? "3px" : "0px",
    }),
    option: (basestyle: any, state: any) => ({
      ...basestyle,
      backgroundColor: isDark
        ? state.isSelected
          ? "#6366F1"
          : state.isFocused
            ? "#1B2430"
            : "#151C26"
        : basestyle.backgroundColor,
      color: textColor,
      border: isDark ? "1px solid #1B2430" : "1px solid #f1f6fe",
    }),
    singleValue: (base: any) => ({
      ...base,
      color: isDark ? textColor : base.color,
    }),
    input: (base: any) => ({
      ...base,
      color: isDark ? textColor : base.color,
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: isDark ? "#151C26" : base.backgroundColor,
      color: isDark ? textColor : base.color,
    }),
    valueContainer: (provided: any, state: any) => ({
      ...provided,
      overflow:
        state.hasValue || state.selectProps.inputValue ? "visible" : "hidden",
    }),
    dropdownIndicator: (base: any, state: any) => ({
      ...base,
      color: "#adb5bd",
      "&:hover": {
        color: indicatorHover,
      },
    }),

    indicatorSeparator: (base: any, state: any) => ({
      ...base,
      backgroundColor: "#adb5bd",
    }),
    clearIndicator: (base: any, state: any) => ({
      ...base,
      color: "#adb5bd",
      "&:hover": {
        color: indicatorHover,
      },
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  };
};

export const calcTCSAmount = (
  amount: number,
  TCS_PERCENTAGE: number
): number => {
  if (!amount || !TCS_PERCENTAGE) return 0;
  return +(amount * (TCS_PERCENTAGE / 100)).toFixed(2);
};

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 50,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export const createInputPropsForNumberField = (
  maxIntegers: number,
  maxDecimals: number,
  allowDecimal: boolean
): InputBaseComponentProps => ({
  className: "no-spinner",
  inputMode: allowDecimal ? "decimal" : "numeric", // Switch based on whether decimals are allowed
  pattern: allowDecimal
    ? `[0-9]{0,${maxIntegers}}[.,]?[0-9]{0,${maxDecimals}}`
    : `[0-9]{0,${maxIntegers}}`,
  step:
    allowDecimal && maxDecimals > 0
      ? `0.${"1".padStart(maxDecimals, "0")}`
      : "1",
  min: 0,
  onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => {
    const key = event.key;
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const decimalSeparator = ".";

    // Check if any text is selected
    const isTextSelected =
      input.selectionStart !== null &&
      input.selectionEnd !== null &&
      input.selectionStart !== input.selectionEnd;

    // Allow overwriting when any text is selected
    if (isTextSelected) {
      return;
    }

    // Allow only numeric values if decimals are not allowed
    if (!allowDecimal) {
      if (!/[0-9]/.test(key)) {
        event.preventDefault();
      }
      if (value.length >= maxIntegers) {
        event.preventDefault();
      }
      return;
    }

    // If decimals are allowed
    if (
      (!/[0-9]/.test(key) && key !== decimalSeparator) ||
      (key === decimalSeparator && value.includes(decimalSeparator))
    ) {
      event.preventDefault();
      return;
    }

    // Restrict the number of integers and decimals
    if (value.includes(decimalSeparator)) {
      const [integerPart, decimalPart] = value.split(decimalSeparator);

      // Restrict the number of decimal places
      if (
        decimalPart &&
        decimalPart.length >= maxDecimals &&
        key !== "Backspace"
      ) {
        event.preventDefault();
      }
    } else {
      // Restrict the number of integer digits
      if (value.length >= maxIntegers && key !== decimalSeparator) {
        event.preventDefault();
      }
    }
  },
  onInput: (event: React.FormEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const decimalSeparator = ".";

    if (!allowDecimal) {
      // If decimals are not allowed, ensure only integer part is valid
      if (value.length > maxIntegers) {
        input.value = value.slice(0, maxIntegers);
      }
      return;
    }

    // Enforce the number of integers and decimals
    if (value.includes(decimalSeparator)) {
      const [integerPart, decimalPart] = value.split(decimalSeparator);

      if (integerPart.length > maxIntegers) {
        input.value =
          integerPart.slice(0, maxIntegers) +
          decimalSeparator +
          (decimalPart || "");
      }

      if (decimalPart && decimalPart.length > maxDecimals) {
        input.value =
          integerPart + decimalSeparator + decimalPart.slice(0, maxDecimals);
      }
    } else if (value.length > maxIntegers) {
      input.value = value.slice(0, maxIntegers);
    }
  },
});



export function round2(value: number): number {
  const str = value.toString();

  const [intPart, decRaw = ""] = str.split(".");

  // take digits as-is (no rounding, no padding by JS)
  const decPart = (decRaw + "000").slice(0, 3);

  const d0 = decPart.charCodeAt(0) - 48; // faster than parseInt
  const d1 = decPart.charCodeAt(1) - 48;
  const d2 = decPart.charCodeAt(2) - 48;

  let result: number;

  if (d2 >= 5) {
    let newD1 = d1 + 1;

    if (newD1 === 10) {
      let newD0 = d0 + 1;

      if (newD0 === 10) {
        result = parseInt(intPart, 10) + 1;
      } else {
        result = parseFloat(`${intPart}.${newD0}0`);
      }
    } else {
      result = parseFloat(`${intPart}.${d0}${newD1}`);
    }
  } else {
    result = parseFloat(`${intPart}.${d0}${d1}`);
  }

  return result;
}


export const refNavigate = (refUsed: any, navigate: any) => {
  const edService = new EncryptDecryptService();
  if (refUsed?.linkId > 0) {
    let enlinkId: any = edService.encrypt(refUsed?.linkId);
    if (refUsed?.linkPage === "SALE_RECEIPT") {
      navigate({
        pathname: "/payment-received-save",
        search: `?q=${encodeURIComponent(enlinkId)}`,
      });
    } else if (refUsed?.linkPage === "VOUCHER_RECEIPT") {
      navigate({
        pathname: "/voucher-save",
        search: `?q=${encodeURIComponent(enlinkId)}&t=receipt`,
      });
    } else if (refUsed?.linkPage === "VOUCHER_PAYMENT") {
      navigate({
        pathname: "/voucher-save",
        search: `?q=${encodeURIComponent(enlinkId)}&t=payment`,
      });
    } else if (refUsed?.linkPage === "VOUCHER_JOURNAL") {
      navigate({
        pathname: "/voucher-save",
        search: `?q=${encodeURIComponent(enlinkId)}&t=journal`,
      });
    } else if (refUsed?.linkPage === "SALE") {
      navigate({
        pathname: "/invoice-save",
        search: `?q=${encodeURIComponent(enlinkId)}&t=tax-invoice`,
      });
    } else if (refUsed?.linkPage === "COMPOSITION_SALE") {
      navigate({
        pathname: "/invoice-save",
        search: `?q=${encodeURIComponent(enlinkId)}&t=composition-invoice`,
      });
    } else if (refUsed?.linkPage === "PURCHASE") {
      navigate({
        pathname: "/purchase-save",
        search: `?q=${encodeURIComponent(enlinkId)}`,
      });
    } else if (refUsed?.linkPage === "PAYMENT") {
      navigate({
        pathname: "/payment-made-save",
        search: `?q=${encodeURIComponent(enlinkId)}`,
      });
    } else if (refUsed?.linkPage === "CREDIT_NOTE") {
      navigate({
        pathname: "/credit-note-save",
        search: `?q=${encodeURIComponent(enlinkId)}`,
      });
    } else if (refUsed?.linkPage === "DEBIT_NOTE") {
      navigate({
        pathname: "/debit-note-save",
        search: `?q=${encodeURIComponent(enlinkId)}`,
      });
    }
  }
};